// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserResearch_container__9ljFu {
    width: 100%;
    height: 100%;
    padding: 40px;
}

.UserResearch_header__lJPHd {
    width: 100%;
    height: 11px;
}

.UserResearch_step_box__qa3mJ {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.UserResearch_step__SrzFb {
    width: 150px;
    height: 11px;
    border-radius: 99px;
    background-color: #dadada;
    cursor: pointer;
}

.UserResearch_step__SrzFb:not(:last-child) {
    margin-right: 25px;
}

.UserResearch_step_active__LjPmQ {
    background-color: #17a8b5;
}

.UserResearch_main__OVCH- {
    width: 100%;
    height: calc(100% - 11px - 43px);
    padding-top: 80px;
}

.UserResearch_gender_info_box__v4HkY {
    width: 100%;
    height: 100%;
}

.UserResearch_gender_topic__Ud9FX {
    font-size: 36px;
    font-weight: bold;
    text-align: center;
    color: #323A45;
    margin-bottom: 50px;
}

.UserResearch_gender_bg_img_box__DKQwk,
.UserResearch_common_bg_img_box__2xGX8 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 90px;
    margin-bottom: 50px;
}

.UserResearch_gender_bg_img__kS6Ek {
    width: 90px;
    height: 90px;
}

.UserResearch_gender_ask__AiOEO,
.UserResearch_common_ask__9kQ20 {
    margin-bottom: 50px;
    font-size: 20px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    text-align: center;
}

.UserResearch_gender_butn_box__NPV9n {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 150px;
    margin-bottom: 50px;
}

.UserResearch_gender_item__VnY8X {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 121px;
    height: 100%;
    -webkit-user-select: none;
            user-select: none;
}

.UserResearch_gender_item__VnY8X:not(:last-child) {
    margin-right: 60px;
}

.UserResearch_gender_item_img__IpO84 {
    width: 80px;
    height: 82px;
    cursor: pointer;
}

.UserResearch_gender_man_img__4Jc4a {
    height: 86px;
}

.UserResearch_item_butn_box__dIDUq {
    width: 121px;
    height: 44px;
}

.UserResearch_item_butn__WYpNC {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 121px;
    height: 44px;
    border: 1px solid #e0e3e8;
    border-bottom-width: 4px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.5s, border-color 0.5s, color 0.5s;
    position: relative;
}

.UserResearch_item_butn__WYpNC:hover {
    color: #17a8b5;
    border-color: #17a8b5;
    background-color: #e4f0f2;
}

.UserResearch_item_butn__WYpNC:active {
    background-color: #a2cfd6;
    top: 3px;
    height: calc(100% - 3px) !important;
    border-bottom-width: 1px;
}

.UserResearch_item_butn_active__tbi41 {
    color: #17a8b5;
    background-color: #fff;
    border: 1px solid #17a8b5;
    border-bottom-width: 4px;
}

.UserResearch_item_butn_active__tbi41:hover {
    background-color: #c6e0e4;
    box-shadow: none;
}

.UserResearch_footer__eLLFH {
    width: 100%;
    height: 43px;
}

.UserResearch_footer_butn_box__ckR7t {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
}

.UserResearch_my_button__CPUd0 {
    width: 133px;
    height: 100%;
}

.UserResearch_previous__76s\\+j {
    margin-right: 16px;
}

.UserResearch_common_info_box__RigAV {
    padding-top: 86px;
}

.UserResearch_common_bg_img_box__2xGX8,
.UserResearch_common_ask__9kQ20 {
    margin-bottom: 35px;
}

.UserResearch_common_butn_box__q8-y8 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
}

.UserResearch_select__9vSt- {
    width: 560px;
    height: 40px;
    border-color: #cbd1d8;
    background-color: #fafafc;
}

.UserResearch_select_open__TZCO7 {

}

.UserResearch_select__9vSt- .ant-select-selector {
    border-color: #cbd1d8 !important;
    box-shadow: none !important;
}

.UserResearch_select__9vSt- .ant-select-selection-item {
    color: #4F4F4F;
}

.UserResearch_select_open__TZCO7 .ant-select-selector {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.custom_select.ant-select-dropdown {
    border: 1px solid #cbd1d8;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top: none;
    margin-top: -4px !important;
    box-shadow: none !important;
    background-color: #fafafc;
}

.custom_select .ant-select-item-option-active {
    background-color: #e4f0f2 !important;
    color: #4F4F4F;
}

.custom_select .ant-select-item-option-active:active {
    background-color: #a2cfd6 !important;
    color: #4F4F4F;
}

.custom_select .ant-select-item-option-selected:not(.ant-select-item-option-disabled),
.custom_select .ant-select-item-option-selected {
    background-color: #c6e0e4 !important;
    color: #17a8b5;
}

.custom_select .rc-virtual-list-scrollbar-thumb {
    background-color: #cbd1d8 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/UserResearch/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,0DAA0D;IAC1D,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,QAAQ;IACR,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;AAEA;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;;IAEI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".container {\n    width: 100%;\n    height: 100%;\n    padding: 40px;\n}\n\n.header {\n    width: 100%;\n    height: 11px;\n}\n\n.step_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.step {\n    width: 150px;\n    height: 11px;\n    border-radius: 99px;\n    background-color: #dadada;\n    cursor: pointer;\n}\n\n.step:not(:last-child) {\n    margin-right: 25px;\n}\n\n.step_active {\n    background-color: #17a8b5;\n}\n\n.main {\n    width: 100%;\n    height: calc(100% - 11px - 43px);\n    padding-top: 80px;\n}\n\n.gender_info_box {\n    width: 100%;\n    height: 100%;\n}\n\n.gender_topic {\n    font-size: 36px;\n    font-weight: bold;\n    text-align: center;\n    color: #323A45;\n    margin-bottom: 50px;\n}\n\n.gender_bg_img_box,\n.common_bg_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 90px;\n    margin-bottom: 50px;\n}\n\n.gender_bg_img {\n    width: 90px;\n    height: 90px;\n}\n\n.gender_ask,\n.common_ask {\n    margin-bottom: 50px;\n    font-size: 20px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    text-align: center;\n}\n\n.gender_butn_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 150px;\n    margin-bottom: 50px;\n}\n\n.gender_item {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 121px;\n    height: 100%;\n    user-select: none;\n}\n\n.gender_item:not(:last-child) {\n    margin-right: 60px;\n}\n\n.gender_item_img {\n    width: 80px;\n    height: 82px;\n    cursor: pointer;\n}\n\n.gender_man_img {\n    height: 86px;\n}\n\n.item_butn_box {\n    width: 121px;\n    height: 44px;\n}\n\n.item_butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 121px;\n    height: 44px;\n    border: 1px solid #e0e3e8;\n    border-bottom-width: 4px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.5s, border-color 0.5s, color 0.5s;\n    position: relative;\n}\n\n.item_butn:hover {\n    color: #17a8b5;\n    border-color: #17a8b5;\n    background-color: #e4f0f2;\n}\n\n.item_butn:active {\n    background-color: #a2cfd6;\n    top: 3px;\n    height: calc(100% - 3px) !important;\n    border-bottom-width: 1px;\n}\n\n.item_butn_active {\n    color: #17a8b5;\n    background-color: #fff;\n    border: 1px solid #17a8b5;\n    border-bottom-width: 4px;\n}\n\n.item_butn_active:hover {\n    background-color: #c6e0e4;\n    box-shadow: none;\n}\n\n.footer {\n    width: 100%;\n    height: 43px;\n}\n\n.footer_butn_box {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.my_button {\n    width: 133px;\n    height: 100%;\n}\n\n.previous {\n    margin-right: 16px;\n}\n\n.common_info_box {\n    padding-top: 86px;\n}\n\n.common_bg_img_box,\n.common_ask {\n    margin-bottom: 35px;\n}\n\n.common_butn_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 40px;\n}\n\n.select {\n    width: 560px;\n    height: 40px;\n    border-color: #cbd1d8;\n    background-color: #fafafc;\n}\n\n.select_open {\n\n}\n\n.select :global(.ant-select-selector) {\n    border-color: #cbd1d8 !important;\n    box-shadow: none !important;\n}\n\n.select :global(.ant-select-selection-item) {\n    color: #4F4F4F;\n}\n\n.select_open :global(.ant-select-selector) {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n:global(.custom_select.ant-select-dropdown) {\n    border: 1px solid #cbd1d8;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-top: none;\n    margin-top: -4px !important;\n    box-shadow: none !important;\n    background-color: #fafafc;\n}\n\n:global(.custom_select .ant-select-item-option-active) {\n    background-color: #e4f0f2 !important;\n    color: #4F4F4F;\n}\n\n:global(.custom_select .ant-select-item-option-active:active) {\n    background-color: #a2cfd6 !important;\n    color: #4F4F4F;\n}\n\n:global(.custom_select .ant-select-item-option-selected:not(.ant-select-item-option-disabled)),\n:global(.custom_select .ant-select-item-option-selected) {\n    background-color: #c6e0e4 !important;\n    color: #17a8b5;\n}\n\n:global(.custom_select .rc-virtual-list-scrollbar-thumb) {\n    background-color: #cbd1d8 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UserResearch_container__9ljFu`,
	"header": `UserResearch_header__lJPHd`,
	"step_box": `UserResearch_step_box__qa3mJ`,
	"step": `UserResearch_step__SrzFb`,
	"step_active": `UserResearch_step_active__LjPmQ`,
	"main": `UserResearch_main__OVCH-`,
	"gender_info_box": `UserResearch_gender_info_box__v4HkY`,
	"gender_topic": `UserResearch_gender_topic__Ud9FX`,
	"gender_bg_img_box": `UserResearch_gender_bg_img_box__DKQwk`,
	"common_bg_img_box": `UserResearch_common_bg_img_box__2xGX8`,
	"gender_bg_img": `UserResearch_gender_bg_img__kS6Ek`,
	"gender_ask": `UserResearch_gender_ask__AiOEO`,
	"common_ask": `UserResearch_common_ask__9kQ20`,
	"gender_butn_box": `UserResearch_gender_butn_box__NPV9n`,
	"gender_item": `UserResearch_gender_item__VnY8X`,
	"gender_item_img": `UserResearch_gender_item_img__IpO84`,
	"gender_man_img": `UserResearch_gender_man_img__4Jc4a`,
	"item_butn_box": `UserResearch_item_butn_box__dIDUq`,
	"item_butn": `UserResearch_item_butn__WYpNC`,
	"item_butn_active": `UserResearch_item_butn_active__tbi41`,
	"footer": `UserResearch_footer__eLLFH`,
	"footer_butn_box": `UserResearch_footer_butn_box__ckR7t`,
	"my_button": `UserResearch_my_button__CPUd0`,
	"previous": `UserResearch_previous__76s+j`,
	"common_info_box": `UserResearch_common_info_box__RigAV`,
	"common_butn_box": `UserResearch_common_butn_box__q8-y8`,
	"select": `UserResearch_select__9vSt-`,
	"select_open": `UserResearch_select_open__TZCO7`
};
export default ___CSS_LOADER_EXPORT___;
